
import React from 'react';
import UrlInput from '@/components/UrlInput';
import { BarChart2, FileText, Database } from 'lucide-react';

interface DashboardLandingProps {
  onSubmit: (url: string) => void;
  isLoading: boolean;
}

const DashboardLanding: React.FC<DashboardLandingProps> = ({
  onSubmit,
  isLoading
}) => {
  return (
    <div className="max-w-6xl mx-auto pt-8 animate-fade-in">
      <div className="mb-6">
        <h1 className="text-3xl md:text-4xl font-bold leading-tight text-center">
          <span className="purple-gradient">Website Crawler & Analysis</span>
        </h1>
      </div>

      <p className="text-lg text-muted-foreground mb-12 max-w-2xl mx-auto text-center">
        Enter a website URL to crawl its pages and extract SEO-relevant data like 
        content, metadata, headings, and schema markup.
      </p>
      
      <div className="max-w-2xl mx-auto neo-card p-4">
        <UrlInput onSubmit={onSubmit} isLoading={isLoading} />
      </div>
      
      <div className="mt-12 neo-card p-6 max-w-3xl mx-auto">
        <h2 className="text-xl font-semibold mb-4 purple-gradient">How it works</h2>
        <div className="space-y-4">
          <div className="flex gap-4 items-start">
            <div className="w-8 h-8 rounded-full bg-primary/20 text-primary flex items-center justify-center flex-shrink-0">
              <Database className="h-4 w-4" />
            </div>
            <div>
              <h3 className="font-medium">Sitemap Discovery</h3>
              <p className="text-sm text-muted-foreground">
                We locate and parse the website's sitemap to find all available pages.
              </p>
            </div>
          </div>
          
          <div className="flex gap-4 items-start">
            <div className="w-8 h-8 rounded-full bg-primary/20 text-primary flex items-center justify-center flex-shrink-0">
              <FileText className="h-4 w-4" />
            </div>
            <div>
              <h3 className="font-medium">Content Extraction</h3>
              <p className="text-sm text-muted-foreground">
                We crawl each page to extract the main content, metadata, headings, and more.
              </p>
            </div>
          </div>
          
          <div className="flex gap-4 items-start">
            <div className="w-8 h-8 rounded-full bg-primary/20 text-primary flex items-center justify-center flex-shrink-0">
              <BarChart2 className="h-4 w-4" />
            </div>
            <div>
              <h3 className="font-medium">Structured Data</h3>
              <p className="text-sm text-muted-foreground">
                All extracted data is organized into a structured format for analysis.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardLanding;
